var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB3IndoorTemperature(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.37 4.63L3 26.89V70h70V26.9L38.37 4.63zM69 66H7V29.1L38.35 9.37 69 29.08V66zM29 19v25.33a11.69 11.69 0 1018 .47V19H29zm8.81 40.69a7.69 7.69 0 01-5.41-13.15L33 46V23h10v23.29l.51.57a7.68 7.68 0 01-5.7 12.83zM42 52a4 4 0 11-6-3.45V26h4v22.55A4 4 0 0142 52z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B3_Indoor_temperature.3bb4f1e4.svg";
export { SvgB3IndoorTemperature as ReactComponent };